export default __webpack_public_path__ + "static/haishi-f92ac6e3180d6d8a8c5327ab6b6a8491.png";